import { render, staticRenderFns } from "./SelectedTagComponent.vue?vue&type=template&id=a10cbba4&"
import script from "./SelectedTagComponent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectedTagComponent.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports